
      var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEnvelope = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 24,
  viewBox: "0 0 30 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 24,
  rx: 4,
  fill: "var(--theme-light,#e2cff7)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.905 5.655h16.19c.574 0 1.105.5 1.105 1.2v10c0 .7-.531 1.2-1.105 1.2H6.905c-.574 0-1.105-.5-1.105-1.2v-10c0-.7.53-1.2 1.105-1.2z",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 1.6,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m6.002 5.867 7.719 6.004a2.087 2.087 0 0 0 2.562 0l7.719-6.004",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 1.6,
  strokeLinejoin: "round"
})));

      const __svgRaw = "<svg width=\"30\" height=\"24\" viewBox=\"0 0 30 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <rect width=\"30\" height=\"24\" rx=\"4\" fill=\"var(--theme-light,#e2cff7)\"/>\r\n    <path d=\"M6.905 5.655h16.19c.574 0 1.105.5 1.105 1.2v10c0 .7-.531 1.2-1.105 1.2H6.905c-.574 0-1.105-.5-1.105-1.2v-10c0-.7.53-1.2 1.105-1.2z\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.6\" stroke-linecap=\"round\"/>\r\n    <path d=\"m6.002 5.867 7.719 6.004a2.087 2.087 0 0 0 2.562 0l7.719-6.004\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.6\" stroke-linejoin=\"round\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/envelope.f6f43d7ce494e3fa5c2a4eacc31b382a.svg"),
        {
          React: SvgEnvelope,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      